import React from 'react';
import { Panel, PanelPresets, UserPermissionsIds } from 'utility/enumerations';
import { ViewMounter } from '../view_mounter';
import { SecureRoute } from '../shared/secure_route';

// TO-DO: Add routes for Admin Dashborad and Suspension form for Admins
function SuspensionsContainerScreen() {
  return (
    <div>
      <SecureRoute
        path="/suspension/new/:cardHolderType/:id"
        pathPermissionId={UserPermissionsIds.ReportChapter893Violations}
        render={(props) => ViewMounter(props, {
          viewPath: 'suspensions/drug_related_suspension/form/new_suspension_form',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/suspension/chapter-893-violations"
        pathPermissionId={UserPermissionsIds.Access893Violations}
        render={(props) => ViewMounter(props, {
          viewPath: 'suspensions/drug_related_suspension/dashboard/893_suspensions_list',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/suspension/violation/:id"
        pathPermissionId={UserPermissionsIds.Read893Violations}
        render={(props) => ViewMounter(props, {
          viewPath: 'suspensions/drug_related_suspension/form/pending_suspension_form',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          viewProps: undefined,
          focusView: false,
          clear: false,
          overrideLocation: undefined,
          params: undefined
        })}
        allowAnonymous={undefined}
        component={undefined}
      />
    </div>
  );
}

export default SuspensionsContainerScreen;
